import React, { useState } from 'react';

const StylistCard = ({ name, image, info }) => {
  const [isFlipped, setIsFlipped] = useState(false);
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

  return (
    <div className={`h-[280px] sm:h-[320px] md:h-[360px] lg:h-[400px] perspective touch-pan-y ${
      isIOS ? 'overflow-hidden' : ''
    }`}>
      <div
        className={`relative preserve-3d w-full h-full transition-transform duration-500 cursor-pointer ${
          isFlipped ? 'rotate-y-180' : ''
        }`}
        onClick={() => setIsFlipped(!isFlipped)}
        style={{ WebkitTransition: 'transform 0.5s', transition: 'transform 0.5s' }}
      >
        {/* Front Card */}
        <div className="absolute inset-0 w-full h-full backface-hidden object-contain">
          <div className="relative w-full h-full rounded-xl shadow-lg overflow-hidden group">
            <img
              src={image}
              alt={name}
              className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
              draggable="false"
            />
            {/* Hover Overlay */}
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent opacity-0 transition-opacity duration-300 group-hover:opacity-100">
              <div className="absolute bottom-4 left-4 text-white transform translate-y-4 opacity-0 transition-all duration-300 group-hover:translate-y-0 group-hover:opacity-100">
                <h2 className="text-lg sm:text-xl md:text-2xl font-bold">{name}</h2>
                <p className="text-sm sm:text-base text-white/80">
                  {isIOS ? 'Tap to view details' : 'Click to flip'}
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Back Card */}
        <div className="absolute inset-0 w-full h-full backface-hidden rotate-y-180">
          <div className="w-full h-full bg-gradient-to-br from-blue-600 to-blue-800 rounded-xl shadow-lg p-4 sm:p-6 text-white">
            <h2 className="text-lg sm:text-xl md:text-2xl font-bold mb-2 sm:mb-4">{name}</h2>
            <div className="space-y-3 sm:space-y-4 overflow-y-auto max-h-[calc(100%-4rem)]">
              <div>
                <h3 className="text-base sm:text-lg font-semibold mb-1 sm:mb-2">Specialties:</h3>
                <div className="space-y-1">
                  {info.specialties.map((specialty, index) => (
                    <p key={index} className="text-sm sm:text-base text-white/90 flex items-center">
                      <span className="w-1.5 h-1.5 sm:w-2 sm:h-2 bg-white rounded-full mr-2 flex-shrink-0" />
                      <span className="line-clamp-1">{specialty}</span>
                    </p>
                  ))}
                </div>
              </div>
              <div>
                <h3 className="text-base sm:text-lg font-semibold mb-1 sm:mb-2">Experience:</h3>
                <p className="text-sm sm:text-base text-white/90">{info.experience}</p>
              </div>
              <div className="absolute bottom-3 sm:bottom-4 right-3 sm:right-4">
                <span className="text-xs sm:text-sm bg-white/20 px-2 sm:px-3 py-1 rounded-full">
                  {isIOS ? 'Tap to close' : 'Click to flip back'}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StylistCard;